import { Badge, type BadgeProps } from "@circleco/compass/components/Badge";

export interface SidebarBadgeProps {
  count: string;
  variant?: BadgeProps["variant"];
}

export const SidebarBadge = ({
  count,
  variant = "secondary",
}: SidebarBadgeProps) => (
  <Badge
    className="shrink-0"
    data-testid="unread-count"
    label={count}
    variant={variant}
  />
);
